import classNames from 'classnames'
import useI18n from 'src/hooks/use_i18n'
import { handleToShopify } from 'src/utils/tools'
import styles from './index.module.scss'

export default function InstallGuide() {
  const { $t } = useI18n()

  return (
    <section className={styles['install-guide']}>
      <h2 className={classNames(styles.title)}>{$t('ResWwwPTrackCenterLP.global.__section5_repurchaseTitle')}</h2>
      <button className={styles.btn} onClick={handleToShopify}>
        <a href="https://apps.shopify.com/17track?utm_source=www.17track.net&utm_medium=track_page&utm_campaign=Add-app-for-your-store">
          {$t('ResWwwPTrackCenterLP.global.__section5_installButton')} &nbsp;➟
        </a>
      </button>
    </section>
  )
}
